import { useState } from "react";

const faqs = [
  {
    q: "ต้องลงทุนเงินไหม?",
    a: "ไม่ต้องลงทุนแม้แต่บาทเดียวค่ะ! ดาวน์โหลดฟรี สมัครฟรี ดูซีรีส์ฟรี แล้วก็รับเหรียญฟรีด้วย ไม่มีค่าใช้จ่ายซ่อนเร้นใดๆ ทั้งสิ้น",
  },
  {
    q: "สมัครสมาชิกอย่างไร?",
    a: "สมัครง่ายมากค่ะ! ใช้เบอร์โทรศัพท์มือถือในการสมัครเท่านั้น ไม่ต้องใช้อีเมลหรือบัญชีโซเชียล กรอกเบอร์โทร รับ OTP แล้วตั้งรหัสผ่าน เสร็จเลย!",
  },
  {
    q: "ถอนเงินได้จริงไหม? ถอนผ่านช่องทางไหน?",
    a: "ได้จริง 100%! เราถอนเงินผ่าน USDT (BEP20) และ USDC เท่านั้น โอนตรงเข้ากระเป๋า Crypto ของคุณ เช่น Binance, OKX, Bybit ฯลฯ ใช้เวลา 24–72 ชั่วโมง",
  },
  {
    q: "ดูกี่ตอนถึงจะได้เหรียญ?",
    a: "ทุก 5 ตอนแรกของแต่ละวันจะได้รับเหรียญรางวัล จำนวนเหรียญขึ้นอยู่กับระดับของคุณ ยิ่งระดับสูง ยิ่งได้เหรียญมากขึ้น นอกจากนี้ยังมีโบนัสจากการชวนเพื่อนและภารกิจประจำวัน",
  },
  {
    q: "ถอนเงินขั้นต่ำเท่าไหร่? มีขั้นสูงสุดไหม?",
    a: "ขั้นต่ำ 3,000 เหรียญ เท่ากับประมาณ ฿100 บาท หรือ $3 USD ไม่มีขั้นสูงสุด ยิ่งสะสมมาก ยิ่งถอนได้มาก!",
  },
  {
    q: "เหรียญแลกเงินได้อัตราเท่าไหร่?",
    a: "เหรียญ = บาท = ดอลลาร์ โดยประมาณ 3,000 เหรียญ ≈ ฿100 บาท ≈ $3 USD อัตราแลกเปลี่ยนอาจมีการปรับตามตลาด Crypto",
  },
  {
    q: "ปลอดภัยไหม? ข้อมูลส่วนตัวจะรั่วไหม?",
    a: "ปลอดภัยมากค่ะ! เราใช้ระบบเข้ารหัสข้อมูลระดับธนาคาร SSL 256-bit ข้อมูลส่วนตัวของคุณจะไม่ถูกเปิดเผยหรือขายให้บุคคลที่สาม บริษัทจดทะเบียนถูกต้องตามกฎหมาย",
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-red-50 text-red-500 text-sm font-semibold px-4 py-1.5 rounded-full mb-4">
            คำถามที่พบบ่อย
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            มีข้อสงสัย? เราตอบได้
          </h2>
          <p className="text-gray-500 text-lg">
            คำถามที่ผู้ใช้ถามบ่อยที่สุด
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="border border-gray-100 rounded-2xl overflow-hidden bg-white hover:border-red-100 transition-colors"
            >
              <button
                className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-gray-900 pr-4 text-sm md:text-base">{faq.q}</span>
                <div className={`w-8 h-8 flex items-center justify-center rounded-full flex-shrink-0 transition-all duration-300 ${
                  openIndex === i
                    ? "bg-gradient-to-br from-red-500 to-orange-400 rotate-45"
                    : "bg-gray-100"
                }`}>
                  <i className={`ri-add-line text-lg ${openIndex === i ? "text-white" : "text-gray-500"}`}></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? "max-h-48 opacity-100" : "max-h-0 opacity-0"
                }`}
              >
                <div className="px-5 md:px-6 pb-5 md:pb-6">
                  <div className="h-px bg-gray-100 mb-4"></div>
                  <p className="text-gray-600 text-sm md:text-base leading-relaxed">{faq.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-12 text-center p-8 bg-gradient-to-r from-red-50 to-orange-50 rounded-2xl border border-red-100">
          <p className="text-gray-700 font-medium mb-4">ยังมีคำถามอื่นอีกไหม?</p>
          <a
            href="https://line.me/ti/p/rwV4hTkrHJ"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-gradient-to-r from-green-500 to-green-400 text-white px-6 py-3 rounded-full font-semibold hover:scale-105 transition-transform cursor-pointer whitespace-nowrap"
          >
            <i className="ri-chat-smile-2-line text-lg"></i>
            ติดต่อผ่าน LINE
          </a>
        </div>
      </div>
    </section>
  );
}
